import { AdvanceInventoryDetails } from '../../component/advance-inventory-details/advance-inventory-details';

export function InventoryDetailsPage() {
  return <AdvanceInventoryDetails />;
}
